import { apiClient } from "./auth";
import type {
  GetOverviewExportHistoryResponse,
  GetOverviewExportStatusResponse,
  OverviewExportDeliveryMode,
  RequestOverviewExportResponse,
} from "./overviewExportTypes";

export type PatientExportGender = "male" | "female" | "other";
export type PatientExportRegistrationStatus = "REGISTERED" | "UNREGISTERED";

export interface PatientExportFilters {
  search?: string;
  gender?: PatientExportGender;
  facilityId?: string[];
  leadSource?: string[];
  registrationStatus?: PatientExportRegistrationStatus;
  createdAtFrom?: string;
  createdAtTo?: string;
}

export interface RequestPatientExportPayload {
  email?: string;
  selectedColumnIds: string[];
  filters?: PatientExportFilters;
  deliveryMode?: OverviewExportDeliveryMode;
}

export async function requestPatientExportApi(
  payload: RequestPatientExportPayload
): Promise<RequestOverviewExportResponse> {
  const res = await apiClient.post<
    RequestPatientExportPayload,
    RequestOverviewExportResponse
  >("/overview/patients/export", payload);
  return res.data;
}

export async function getPatientExportStatusApi(
  exportId: string
): Promise<GetOverviewExportStatusResponse> {
  const res = await apiClient.get<GetOverviewExportStatusResponse>(
    `/overview/patients/export/${encodeURIComponent(exportId)}`
  );
  return res.data;
}

export async function getPatientExportHistoryApi(params?: {
  limit?: number;
  offset?: number;
}): Promise<GetOverviewExportHistoryResponse> {
  const query = new URLSearchParams();
  if (params?.limit != null) query.append("limit", String(params.limit));
  if (params?.offset != null) query.append("offset", String(params.offset));
  const url = query.toString()
    ? `/overview/patients/export/history?${query.toString()}`
    : "/overview/patients/export/history";
  const res = await apiClient.get<GetOverviewExportHistoryResponse>(url);
  return res.data;
}
